module.exports = __webpack_public_path__ + "img/Monte_Kope_90.dcad32cf.jpg";